import React from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { RoutesConfig } from "./components/routes/routesConfig";

export const App: React.FC = () => {
  return (
    <Router>
      <RoutesConfig />
    </Router>
  );
};

export default App;
